import React from 'react';

export type ScoringMode = 'ml' | 'rule_based';

interface ScoringModeToggleProps {
  mode: ScoringMode;
  onChange: (mode: ScoringMode) => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
}

const ScoringModeToggle: React.FC<ScoringModeToggleProps> = ({
  mode,
  onChange,
  disabled = false,
  loading = false,
  className = ''
}) => {
  const isDisabled = disabled || loading;

  return (
    <div className={`flex items-center gap-3 p-3 bg-gray-50 rounded-lg ${className}`}>
      <span className="text-sm font-medium text-gray-700">Scoring:</span>

      <div className="flex bg-gray-200 rounded-lg p-1">
        <button
          onClick={() => onChange('rule_based')}
          disabled={isDisabled}
          className={`px-4 py-1.5 text-sm font-medium rounded-md transition-all duration-200 ${
            mode === 'rule_based'
              ? 'bg-blue-600 text-white shadow-sm'
              : 'text-gray-600 hover:bg-gray-300'
          } ${isDisabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        >
          Physics Based + AI Insights
        </button>
        <button
          onClick={() => onChange('ml')}
          disabled={isDisabled}
          className={`px-4 py-1.5 text-sm font-medium rounded-md transition-all duration-200 ${
            mode === 'ml'
              ? 'bg-green-ink text-white shadow-sm'
              : 'text-gray-600 hover:bg-gray-300'
          } ${isDisabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        >
          ML Model (Beta)
        </button>
      </div>

      <span className="text-xs text-gray-500">
        {mode === 'rule_based' ? (
          <>
            <span className="font-medium text-blue-600">V5.1</span>
            <span className="ml-1">Physics + AI Scoring</span>
          </>
        ) : (
          <>
            <span className="font-medium text-green-ink">V6.1</span>
            <span className="ml-1">XGBoost (Beta)</span>
          </>
        )}
      </span>

      {loading && (
        <div className="ml-2">
          <svg className="animate-spin h-4 w-4 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </div>
      )}
    </div>
  );
};

export default ScoringModeToggle;
